import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../context/LangContext";
import { pickLang } from "../lib/i18n";

const SITE_NAME = "MP Sound";
const DEFAULT_TITLE = {
  en: "MP Sound — Pro Audio, Lighting & AV in Cyprus",
  gr: "MP Sound — Επαγγελματικός Ήχος, Φωτισμός & AV στην Κύπρο",
};
const DEFAULT_DESC = {
  en: "Sound system rental, lighting rigs, lasers, repairs and turn-key venue installs across Cyprus. From after-dark clubs to open-air festivals.",
  gr: "Ενοικίαση ηχητικών συστημάτων, φωτισμού, lasers, επισκευές και ολοκληρωμένες εγκαταστάσεις χώρων σε όλη την Κύπρο.",
};
const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/50590957-5819-4a6e-b3ee-9ef342eeb207/images/efc9fd2474b62ac617f26b3a3afadecf347bb2ab97e9ebc758a2dcad9e294cbf.png";

export default function SEO({ title, description, image, path = "" }) {
  const { lang } = useLang();
  const t = title ? pickLang(title, lang) : pickLang(DEFAULT_TITLE, lang);
  const d = description ? pickLang(description, lang) : pickLang(DEFAULT_DESC, lang);
  const fullTitle = title ? `${t} — ${SITE_NAME}` : t;
  const ogImage = image || DEFAULT_OG;
  const url = `${typeof window !== "undefined" ? window.location.origin : ""}${path}`;

  return (
    <Helmet>
      <html lang={lang === "gr" ? "el" : "en"} />
      <title>{fullTitle}</title>
      <meta name="description" content={d} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="theme-color" content="#08080a" />
    </Helmet>
  );
}
